<template>
    <v-container class="pa-0">
        <v-btn-toggle v-model="toggle_exclusive">
            <v-btn :height="isShopPage? '32' : '40'" x-small @click="decrementQuantity()">
                <fa :icon="['fal', customIcon]" class="fa-md" />
            </v-btn>
            <v-text-field
                v-model="inputFieldValue"
                type="number"
                :class="{'input-stepper': true, 'shop-page-input': isShopPage}"
                outlined
                :autofocus="enableAutofocus"
                :rounded="false"
                dense
                :hide-details="true"
                @keydown="handleMaxLimit($event)"
            ></v-text-field>
            <v-btn :height="isShopPage? '32' : '40'" x-small @click="incrementQuantity()">
                <fa :icon="['fal', 'plus']" class="fa-md" />
            </v-btn>
        </v-btn-toggle>
    </v-container>
</template>
<script>
export default {
    name: 'InputFieldStepper',
    components: {},
    props: {
        item: {
            type: Object,
            default: null,
        },
        pkgQtyType: {
            type: String,
            default: 'standard',
        },
        isShopPage: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            toggle_exclusive: null,
            enableAutofocus: false,
        }
    },
    computed: {
        inputFieldValue: {
            get() {
                return this.item ? this.item.quantityInCart : 1
            },
            set(val) {
                const qty = val === '' ? 1 : parseInt(val)
                if (qty <= 99999) {
                    this.updateQuantity(qty)
                }
            },
        },
        customIcon() {
            if (this.item) {
                const stepperQty =
                    this.pkgQtyType === 'standard' &&
                    Number.isInteger(this.item.pkgqty)
                        ? this.item.pkgqty
                        : 1
                return this.inputFieldValue === stepperQty
                    ? 'trash-alt'
                    : 'minus'
            } else {
                return 'minus'
            }
        },
        stepperQty() {
            return this.pkgQtyType === 'standard' &&
                Number.isInteger(this.item.pkgqty)
                ? this.item.pkgqty
                : 1
        },
    },
    mounted() {
        if (this.$vuetify.breakpoint.smAndUp) {
            this.enableAutofocus = true
        }
    },
    watch: {
        pkgQtyType(newVal, oldVal) {
            if (newVal === 'standard') {
                this.updateQuantity(
                    Number.isInteger(this.item.pkgqty) ? this.item.pkgqty : 1
                )
            }
        },
    },
    methods: {
        incrementQuantity() {
            this.$store.dispatch('cart/incrementQty', {
                ...this.item,
                stepperQty: this.stepperQty,
            })
        },
        decrementQuantity() {
            if (this.item.quantityInCart === this.stepperQty) {
                this.$store.dispatch('cart/removeItem', this.item)
            } else {
                this.$store.dispatch('cart/decrementQty', {
                    ...this.item,
                    stepperQty: this.stepperQty,
                })
            }
        },
        updateQuantity(quantityValue) {
            if (
                quantityValue % this.stepperQty !== 0 &&
                this.pkgQtyType === 'standard'
            ) {
                const productObj = this.item
                const cleanPkgQty = Number.isInteger(this.item.pkgqty)
                    ? this.item.pkgqty
                    : 1
                const qty =
                    cleanPkgQty * Math.round(quantityValue / cleanPkgQty)
                this.$store.dispatch('cart/setQty', {
                    productObj,
                    qty,
                    stepperQty: this.stepperQty,
                })
            } else {
                const productObj = this.item
                this.$store.dispatch('cart/setQty', {
                    productObj,
                    qty: quantityValue,
                    stepperQty: this.stepperQty,
                })
            }
        },
        handleMaxLimit(event) {
            if (
                ((event.keyCode >= 48 && event.keyCode <= 57) ||
                    (event.keyCode >= 96 && event.keyCode <= 105)) &&
                event.target.value.length > 4
            ) {
                event.preventDefault()
                return false
            }
        },
    },
}
</script>
<style lang="scss">
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type='number'] {
    -moz-appearance: textfield;
}

.shop-page-input .v-input__slot {
    min-height: 32px !important;
    height: 32px !important;
    width: 44px !important;
    font-size: 12px !important;
}
</style>
